import { Component, OnInit, ChangeDetectionStrategy, Renderer2, OnDestroy } from '@angular/core';

import * as State from '@shared/state';
import * as Services from '@shared/core/services';

import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'shared-modals',
    templateUrl: './modals.shared.component.html',
    styleUrls: ['./modals.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalsComponent implements OnInit, OnDestroy {
    private _modalsForBodyScrollListener: Subscription;

    public modals$: Observable<State.IModal[]>;
    public isClosingAllModals$: Observable<boolean>;

    constructor(
        public modalsService: Services.ModalsService,
        public renderer2: Renderer2,
    ) {
        this.modals$ = this.modalsService.modalsList$;

        this.isClosingAllModals$ = this.modalsService.isClosingAllModals$;

        this._modalsForBodyScrollListener = this.modalsService.isAnyModalVisible$
            .subscribe(isVisible => {
                if (isVisible) {
                    return this.renderer2.setStyle(document.body, 'overflow', 'hidden');
                }

                this.renderer2.setStyle(document.body, 'overflow', null);
            });
    }

    ngOnInit(): void { }

    ngOnDestroy(): void {
        if (this._modalsForBodyScrollListener && !this._modalsForBodyScrollListener.closed) this._modalsForBodyScrollListener.unsubscribe();
    }

    public handleBackdropClick($event: Event): void {
        window.dispatchEvent(new Event('olo:modal:backdrop-click'));
    }


    public trackBy(index: number, modal: State.IModal): number {
        return modal?.id || index;
    }
}
